import type { BlockPlaceRepositoryConfig } from '@jtnews/shared/seedwork/frontend/domain';

import type { ILogger } from '../logger';

export type BlockUseCaseConfig = {
  deps: {
    logger: ILogger;
  };
};

export interface IBlockUseCase {
  setBlockPlace(blockPlaceConfig: BlockPlaceRepositoryConfig): void;
}

export abstract class BlockUseCase {
  protected logger: ILogger;
  constructor(config: BlockUseCaseConfig) {
    const {
      deps: { logger },
    } = config;

    this.logger = logger;
  }
}
